/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InitialPremiumPaymentStatus {
  COMPLETED_BY_EMPLOYEE = 'COMPLETED_BY_EMPLOYEE',
  COMPLETED_BY_AGENT = 'COMPLETED_BY_AGENT',
  NOT_SET_UP_BY_EMPLOYEE = 'NOT_SET_UP_BY_EMPLOYEE',
  NOT_SET_UP_BY_AGENT = 'NOT_SET_UP_BY_AGENT',
  SET_UP_BY_EMPLOYEE = 'SET_UP_BY_EMPLOYEE',
  SET_UP_BY_AGENT = 'SET_UP_BY_AGENT',
}
